import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Button, Box } from '@material-ui/core'

import { faTrash, faPencil, faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import UserAware from 'components/UserAware'

const ActionsCell = ({ record, onEdit, onDelete, onRolesEdit, isUserPermitted }) => (
  <Fragment>
    <Button
      color="primary"
      onClick={onEdit}
    >
      <FontAwesomeIcon icon={faPencil} /> &nbsp; Edit
    </Button>
    <UserAware
      render={(user) => (
        <Fragment>
          {(isUserPermitted || user.Id === record.Id) && (
            <Box
              borderLeft={1}
              borderColor="grey.300"
              component="span"
              ml={1}
              pl={1}
            >
              <Button
                color="primary"
                onClick={onRolesEdit}
              >
                <FontAwesomeIcon icon={faCog} /> &nbsp; Roles
              </Button>
            </Box>
          )}
          {isUserPermitted && user.Id !== record.Id && (
            <Box
              color="error.dark"
              component="span"
              borderLeft={1}
              borderColor="grey.300"
              ml={1}
              pl={1}
            >
              <Button
                color="inherit"
                onClick={onDelete}
              >
                <FontAwesomeIcon icon={faTrash} /> &nbsp; Delete
              </Button>
            </Box>
          )}
        </Fragment>
      )}
    />
  </Fragment>
)

ActionsCell.propTypes = {
  record: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRolesEdit: PropTypes.func.isRequired,
  isUserPermitted: PropTypes.bool,
}

export default ActionsCell
